import { render, staticRenderFns } from "./StudioProjectPieces.vue?vue&type=template&id=63848c02&scoped=true&"
import script from "./StudioProjectPieces.vue?vue&type=script&lang=js&"
export * from "./StudioProjectPieces.vue?vue&type=script&lang=js&"
import style0 from "./StudioProjectPieces.vue?vue&type=style&index=0&id=63848c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63848c02",
  null
  
)

export default component.exports